document.addEventListener("DOMContentLoaded", function () {
  function mobilePredictive() {
    const searchButton = document.getElementById("cst_mobile_search");
    const searchContainer = document.querySelector(".cst_search-container");
    const closeSearch = document.getElementById("cst_close_search");
    const searchSubmitBtn = document.getElementById("cst_search_submit");
    const searchInput = document.getElementById("cst_search_input");

    const overlay = document.querySelector(".cst_search-overlay");
    const searchResults = document.getElementById("cst_search_results");

    function openSearch() {
      searchContainer.classList.add("open");
      overlay.classList.add("active");
      searchInput.focus();
    }

    function closeSearchBar() {
      searchContainer.classList.remove("open");
      overlay.classList.remove("active");
      searchResults.style.display = "none";
    }

    searchButton.addEventListener("click", function (event) {
      event.stopPropagation();
      openSearch();
    });

    closeSearch.addEventListener("click", function (event) {
      event.stopPropagation();
      closeSearchBar();
    });

    overlay.addEventListener("click", closeSearchBar);

    async function fetchSearchResults(query) {
      const shopifyEndpoint = `/search/suggest.json?q=${query}&resources[type]=product`;

      try {
        // console.log(`Fetching search results for: "${query}"`);

        const response = await fetch(shopifyEndpoint);

        if (!response.ok) {
          throw new Error(`HTTP Error! Status: ${response.status}`);
        }

        const data = await response.json();

        // console.log("Raw API Response:", data);

        renderSearchResults(data.resources.results.products);
      } catch (error) {
        console.error("Error fetching search results:", error);
      }
    }

    function renderSearchResults(products) {
      searchResults.innerHTML = "";

      if (products.length === 0) {
        console.log("No products found.");
        // searchResults.style.display = "none";
        searchResults.innerHTML = "    No products found.";
        return;
      }

      // console.log("Products found:", products);

      products.forEach((product) => {
        const li = document.createElement("li");
        const a = document.createElement("a");
        const img = document.createElement("img");

        a.href = product.url;
        a.textContent = product.title;

        img.src = product.image
          ? product.image
          : "https://cdn.shopify.com/s/files/1/0429/0281/4882/files/Logo_4a0b9c8a-babd-4a70-97dc-72905d23b613.png?v=1630537725";

        li.appendChild(img);
        li.appendChild(a);
        searchResults.appendChild(li);
      });

      searchResults.style.display = "block";
    }

    searchInput.addEventListener("input", function () {
      const query = searchInput.value.trim();

      if (query.length > 0) {
        fetchSearchResults(query);
      } else {
        searchResults.style.display = "none";
      }
    });

    searchSubmitBtn.addEventListener("click", function () {
      const query = searchInput.value.trim();
        window.location.href = `/search?q=${encodeURIComponent(searchInput.value.trim())}`;
    });

    document.addEventListener("click", function (event) {
      if (
        !searchInput.contains(event.target) &&
        !searchResults.contains(event.target)
      ) {
        searchResults.style.display = "none";
      }
    });
  }
  mobilePredictive();
});
